<template>
  <div :class="['home-page', { 'no-scroll': isPopOpen }]">
    <div class="color-bg"></div>
    <div class="home-bg">
      <img src="@/assets/bg1.png">
      <img src="@/assets/bg2.png">
      <img src="@/assets/bg3.png">
      <img src="@/assets/bg4.png">
      <img src="@/assets/bg5.png">
      <img src="@/assets/bg6.png">
      <img src="@/assets/bg7.png">
    </div>
    <div class="jxw_box">
      <a class="ljkh_btn" @click="axiosUserClcik('ljkh')">
        <img class="icon" src="@/assets/ljkh_btn.png">
        <img class="finger" src="@/assets/hand_tips.png">
      </a>
      <div class="ykh_btn" @click="axiosUserClcik('ykh')">
        <img class="icon" src="@/assets/ykh_btn.png">
        <img class="finger" src="@/assets/hand_tips.png">

      </div>
    </div>
    <div class="rule_btn" @click="ruleBtnClick">
      <img src="@/assets/rule_btn.png">
    </div>
  </div>
</template>

<script>
import store from '@/store';
import Vuex from 'vuex'

var mapGetters = Vuex.mapGetters;
export default {
  name: 'HomePage',
  data() {
    return {
      // isPopOpen: false,
      isAxios: false,
      typeStr: "",
      kaiHuURL: "https://www.citic-wealth.com/wechat/product/?pageFlag=shhd2&posId=nancai2024&posName=5Y2X6LSiMjAyNA==#/bindBusinessNew"
    };
  },
  props: {
  },
  computed: {
    // 使用 mapGetters 辅助函数来映射 Vuex getter 到计算属性
    isPopOpen: function () {
      return this.$store.getters.isPopOpen;
    }
  },
  methods: {

    axiosUserClcik(btnName) {
      var that = this;
      console.log("点击" + btnName + "按钮 isLogin=", that.$store.state.isLogin);

      if (that.$store.state.isLogin) {//已登录
        if (that.isAxios) {
          return;
        }
        that.isAxios = true;

        //传参类型
        var typeStr = "";
        if (btnName === "ljkh") {
          typeStr = "立即开户";
        } else if (btnName === "ykh") {
          typeStr = "领奖";
        }

        that.$axios({
          method: 'get',
          url: 'https://event.21jingji.com/xin_yin/userClick',
          params: {
            // 请求参数
            // type: "领奖"
            type: typeStr
          }
        }).then(function (response) {

          console.log(response.data);
          var responseData = response.data;

          if (Number(responseData.status) === 1) {
            if (btnName === "ljkh") {
              that.ljkhBtnClick();
            } else if (btnName === "ykh") {
              that.ykhBtnClick();
            }
            that.isAxios = false;
          } else {
            console.error('userClick接口  携参【领奖】 报错：', responseData.msg);
          }
          that.isAxios = false;
        })
          .catch(function (error) {
            that.isAxios = false;
            console.error('userClick接口  携参【领奖】 报错：', error);
            if (btnName === "ljkh") {
              that.ljkhBtnClick();
            } else if (btnName === "ykh") {
              that.ykhBtnClick();
            }
          })

      } else {//未登录 （本地测试）

        if (btnName === "ljkh") {
          that.ljkhBtnClick();
        } else if (btnName === "ykh") {
          that.ykhBtnClick();
        }
      }
    },
    //活动规则 已开户 二维码
    ruleBtnClick() {
      this.$store.commit('showRulePop');
    },

    //已开户 二维码
    ykhBtnClick() {
      var that = this;
      var that = this;
      if (that.$store.state.isLogin) {
        that.$store.commit('showQrPop');
      } else {
        // window.sys_user.login();
        if (process.env.NODE_ENV === 'production') {
          that.newLink('https://m.21jingji.com/plus/user/login?referer_url=' + window.location.href, "login");
        } else {
          that.$store.commit('showQrPop');
        }
      }
    },

    //立即开户 跳链接
    ljkhBtnClick() {
      var that = this;
      if (that.$store.state.isLogin) {//已登录
        // window.location.href = this.kaiHuURL;

        //跳转会被拦截
        //window.open(that.kaiHuURL, '_self');

        //plan B
        that.newLink(that.kaiHuURL, "kaihu");
      } else {//未登录
        // window.sys_user.login();
        that.newLink('https://m.21jingji.com/plus/user/login?referer_url=' + window.location.href, "login");
      }
    },
    newLink(url, id) {
      var a = document.createElement('a');
      a.setAttribute('href', url);
      a.setAttribute('target', '_self');
      a.setAttribute('id', id);
      // 防止反复添加
      if (!document.getElementById(id)) {
        document.body.appendChild(a);
      }
      a.click();


      // var form = document.createElement('form');
      // form.action = 'https://m.21jingji.com/plus/user/login?referer_url=' + window.location.href;
      // form.target = '_self';
      // form.method = 'POST';
      // document.body.appendChild(form);
      // form.submit();


      // console.log("plan B")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '@/static/preboot.less';
@import '@/static/JAnimate.less';

.home-page {
  position: absolute;
  width: 100%;
  height: (3050/@rem);
  overflow: hidden;
}

.color-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  background-image: url("../assets/color_bg.jpg");

  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}

.home-bg img {
  display: block;
  width: 100%;
}

.home-bg {
  position: absolute;
  width: 100%;
}

.jxw_box {
  position: absolute;
  left: (36/@rem);
  top: (419/@rem);
  width: (714/@rem);
  height: (737/@rem);
  max-width: 714px !important;
  max-height: 737px !important;

  background-image: url("../assets/jxw_icon.png");
  background-size: contain;
  background-repeat: no-repeat;
  // width: (714/@vw);
  // height: (737/@vw);

  // width: 714px;
  // height: 737px;
}

.ljkh_btn {
  position: absolute;
  width: (259/@rem);
  height: (155/@rem);
  left: (276/@rem);
  top: (408/@rem);
  // opacity: 0.5;

  .icon {
    position: absolute;
    width: (259/@rem);
    height: (155/@rem);
    left: 0;
    transform: rotate(-9.5deg);
    .animation(opacity0to1 1s linear infinite);

  }

  .finger {
    position: absolute;
    left: (26/@rem);
    top: (130/@rem);
    width: (40/@rem);
    height: (53/@rem);
    .animation(UpToDown 1s linear infinite);
  }
}

.ykh_btn {
  position: absolute;
  width: (238/@rem);
  height: (65/@rem);
  left: (306/@rem);
  top: (591/@rem);

  .icon {
    position: absolute;
    width: (238/@rem);
    height: (65/@rem);
    left: 0;

    transform: rotate(-9.5deg);
    .animation(opacity1to0 0.8s linear infinite);
  }

  .finger {
    position: absolute;
    left: (10/@rem);
    top: (50/@rem);
    width: (40/@rem);
    height: (53/@rem);

    .animation(DownToUp 1s linear infinite);
  }
}

.rule_btn {
  position: absolute;
  right: -2px;
  top: (34/@rem);
  width: (119/@rem);
  height: (52/@rem);

  img {
    width: 100%
  }

  .animation(ScaleS2B2S 1s linear infinite);
}


.no-scroll {
  position: fixed !important;
  ;
  overflow: hidden !important;
  /* 当弹窗打开时，禁止滚动 */
  height: 100vh !important;
  /* 固定视口的高度 */
  top: 0;
}
</style>
